import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/weeklyView${`?startDate=${string}&endDate=${string}&datesToLoad=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/weeklyView`;

export const URL = (
	/** format: MM-DD-YYYY */startDate: string, /** format: MM-DD-YYYY */endDate: string, /** format: MM-DD-YYYY */datesToLoad: string[]
): RouteDefinition =>
	`${baseRoute}/weeklyView?startDate=${startDate}&endDate=${endDate}&datesToLoad=${JSON.stringify(datesToLoad)}`;
